/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
import {Routes} from '@angular/router';
import {PersonalDetailsPageComponent} from './personal-details-page.component';
import {BasicInfoScreenComponent} from './steps/basic-info/basic-info-screen.component';
import {ContactScreenComponent} from './steps/contact/contact-screen.component';
import {IdentificationScreenComponent} from './steps/identification/identification-screen.component';
import {AdminReportsScreenComponent} from './steps/admin-reports/admin-reports-screen.component';
import {AuthInfo} from '../../components/security/authorization/auth.guard';

export const rootRoutePath = 'personal-details';

const routes: Routes = [{
    path: rootRoutePath,
    component: PersonalDetailsPageComponent,
    children: [
        {path: '', redirectTo: 'basicInfo', pathMatch: 'full'},
        {path: 'basicInfo', component: BasicInfoScreenComponent},
        {path: 'contact', component: ContactScreenComponent},
        {path: 'identification', component: IdentificationScreenComponent},
        {path: 'adminReports', component: AdminReportsScreenComponent, data: {auth: new AuthInfo({roles: ['ADMIN']})}}
    ],
    data: {section: {title: 'Personal Details'}, impersonationAllowed: true}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/personal-details-page.routing.ts